import { captureMessage } from '@/utils/errorMonitoring';

// Written by the inline #stale-bundle-recovery script in src/index.html just
// before it reloads a page whose bundle failed to load. Keep the strings equal.
// Clearing it here, once the app has started, is what lets that script treat a
// note that is still present as "the reload did not help" and stop reloading.
export const STALE_BUNDLE_RELOAD_KEY = 'mento:stale-bundle-reload';

type StaleBundleReloadNote = {
  at?: number;
  src?: string;
};

const readNote = (): StaleBundleReloadNote | null => {
  try {
    const raw = window.sessionStorage.getItem(STALE_BUNDLE_RELOAD_KEY);
    if (!raw) return null;
    window.sessionStorage.removeItem(STALE_BUNDLE_RELOAD_KEY);
    return JSON.parse(raw) as StaleBundleReloadNote;
  } catch {
    return null;
  }
};

export const reportStaleBundleRecovery = () => {
  const note = readNote();
  if (!note) return;

  captureMessage('stale_bundle_recovered', {
    extra: {
      failed_src: note.src,
      reload_age_ms:
        typeof note.at === 'number' ? Date.now() - note.at : undefined,
    },
    level: 'warning',
  });
};
